import Image from "next/image";
import React, { useState } from "react";
import EllipsisText from "react-ellipsis-text";
import { useScrollDirection } from "react-use-scroll-direction";
import { ImageButton } from "../Buttons";
import CartIconSvg from "../NavBar2/CartIconSvg";
import { parseFileName } from "../utils/fileutil";

const NavBar = (props) => {
  const [direction, setDirection] = React.useState(String);
  const { isScrollingUp, isScrollingDown } = useScrollDirection();
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  React.useEffect(() => {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);

  const checkoutShouldHide = () => {
    let shouldHide = false;
    if (typeof window != "undefined") {
      if (window.scrollY > 120) {
        shouldHide = true;
      }
    }
    return shouldHide;
  };

  const makeBGWhite = () => {
    let shouldHide = false;
    if (typeof window != "undefined") {
      if (window.scrollY > 30) {
        shouldHide = true;
      }
    }
    return shouldHide;
  };

  return (
    <header
      className={`flex flex-row justify-between items-center h-[72px] w-full z-[99] fixed top-0 left-1/2 max-w-[var(--max-width)] bg-transparent -translate-x-1/2 opacity-100 transition-all duration-300 ease-in-out
        ${direction === "up" ? "bg-white" : ""} 
        ${direction === "down" && checkoutShouldHide() ? "-top-[60px]" : ""} 
        ${direction === "down" && makeBGWhite() ? "!bg-white" : ""} mb-5`}
    >
      <div className="mx-auto w-full max-w-[var(--max-width)] flex items-center justify-between h-[5rem] p-[0.5rem_22px]">
        <div className="relative flex justify-center items-center z-10 w-full">
          {props.store.homePageEnabled && (
            <button
              className="bg-transparent border-none absolute left-0"
              onClick={() => {
                console.log("Toggling side navigation:", !isSideNavOpen);
                props.toggleSideNav();
              }}
            >
              <span className="block w-6 h-0.5 bg-primary mb-1"></span>
              <span className="block w-6 h-0.5 bg-primary mb-1"></span>
              <span className="block w-6 h-0.5 bg-primary"></span>
            </button>
          )}
          {props.store?.logo ? (
            <Image
              unoptimized={true}
              src={(() => {
                const urlPath = props.store.logo ? new URL(props.store.logo).pathname : "";
                const extractedImageName = parseFileName(urlPath).name;
                return `https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/${extractedImageName}.jpg?quality=50`;
              })()}
              alt={`${props.store.storeName} Logo`}
              width={props.theme?.logoShape === "rectangle" ? 120 : 60}
              height={60}
              className={`object-contain ${props.theme?.logoShape === "rectangle" ? "" : "rounded-full"}`}
              layout="fixed"
              onClick={() => (window.location.href = window.location.origin)}
            />
          ) : (
            <h2
              className="inline-block text-lg font-bold font-lato text-black text-center"
              onClick={() => (window.location.href = window.location.origin)}
            >
              <EllipsisText text={props.storeName} length={25} tail="..." />
            </h2>
          )}
          <span className="z-10 absolute right-0">
            {props.cartActive && !props.hideInAdvance ? (
              <ImageButton action={() => props.handleShowCart(true)}>
                <CartIconSvg />
              </ImageButton>
            ) : (
              ""
            )}
          </span>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
